import { computed, Directive, effect, ElementRef, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { EventBusService } from '@big-direkt/event-bus';
import { ExternalLinkService } from '../services/external-link.service';

@Directive({
    selector: 'a[href]', // eslint-disable-line @angular-eslint/directive-selector
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[attr.href]': 'href()',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[attr.rel]': 'relAttr()',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[attr.target]': 'targetAttr()',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '(click)': 'onClick($event.target)',
    },
    exportAs: 'link',
})
export class HrefLinkDirective {
    private readonly elementRef = inject(ElementRef);
    private readonly externalLinkService = inject(ExternalLinkService);
    private readonly eventBus = inject(EventBusService);
    private readonly routerLinkWithHref = inject(RouterLink, { optional: true });

    public readonly href = input.required<string>();

    public readonly isExternal = computed(() => {
        const href = this.href();

        return this.externalLinkService.isPhoneNumber(href) || this.externalLinkService.isExternal(href);
    });

    protected readonly relAttr = computed(() => this.externalLinkService.getRel(this.isExternal()));
    protected readonly targetAttr = computed(() => this.externalLinkService.getTarget(this.isExternal()));

    constructor() {
        effect(() => {
            const isExternal = this.isExternal();

            // eslint-disable-next-line no-null/no-null
            if (this.elementRef.nativeElement.getAttribute('download') !== null) {
                this.deactivateRouterLink();

                return;
            }

            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, sonarjs/different-types-comparison
            if (!isExternal || this.routerLinkWithHref === undefined) {
                return;
            }

            this.deactivateRouterLink();
        });
    }

    public onClick(target: HTMLElement): void {
        if (target.classList.contains('dropdown-toggle')) {
            return;
        }

        const targetUrl: string | null = this.elementRef.nativeElement.getAttribute('href');

        // eslint-disable-next-line no-null/no-null
        if (targetUrl === null) {
            return;
        }

        this.eventBus.emit({ key: 'page_navigation_event', data: { triggerElement: target, targetUrl } });
    }

    private deactivateRouterLink(): void {
        if (!this.routerLinkWithHref) {
            return;
        }

        this.routerLinkWithHref.onClick = (): boolean => true;
    }
}
